import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setBrand } from 'actions/appActions';
import AppFilter from 'containers/AppFilter/AppFilter';
import MobileAppFilter from 'containers/MobileAppFilter/MobileAppFilter';

class App extends React.Component {
  state = {
    width: window.innerWidth,
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentDidMount() {
    this.props.dispatchSetBrand(this.props.brand);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const isMobile = this.state.width >= 992;
    return (
      <React.Fragment>
        {
          isMobile
            ? <AppFilter width={this.state.width} movieId={this.props.movieId} />
            : <MobileAppFilter width={this.state.width} movieId={this.props.movieId} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  dispatchSetBrand: setBrand,
};

App.propTypes = {
  movieId: PropTypes.string.isRequired,
  dispatchSetBrand: PropTypes.func.isRequired,
  brand: PropTypes.string,
};

App.defaultProps = {
  brand: null,
};

export default connect(null, mapDispatchToProps)(App);
